// extracted by mini-css-extract-plugin
export default {"container":"dJ-z","timeTop":"eJ-z","timeCountdown":"fJ-z","cta":"gJ-z","disabled":"hJ-z","product":"iJ-z"};